import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { Media } from '@shared-features/models';
import { MediaType } from '../enums/shared-enums.enum';

@Injectable({
  providedIn: 'root',
})
export class MediaAPI {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  uploadMedia(file: File, type: MediaType): Observable<Media[]> {
    let formData: FormData = new FormData();
    formData.append('media', file, file.name);
    formData.append('type', type);

    let headers = new Headers();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.baseAPI
      .post(APIConstants.API_UPLOAD_MEDIA, formData, { headers: headers })
      .pipe(
        map((res) => {
          return this.mapper.fromJson(Media, res.data);
        })
      );
  }

  uploadMedias(files: File[], type: MediaType): Observable<Media[][]> {
    return zip(...files.map(file => this.uploadMedia(file, type)));
  }

  getMedia(id: number): Observable<Media> {
    return this.baseAPI
      .get(APIConstants.API_GET_MEDIA_BY_ID + id)
      .pipe(map((res) => this.mapper.fromJson(Media, res.data)));
  }

}
